export default __webpack_public_path__ + "static/media/PrivacyPolicy_09_22.f945b238.pdf";